module.exports = __webpack_public_path__ + "img/logo-brand-classic-milano.d1c87cd6.svg";